import React, { useState, useEffect, useContext } from "react";
import "./index.scss";
import { HeaderConfig } from "./config";
import { HTTP_METHODS, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import CustomTable from "../../../core/custom-table";
import CustomButtonComponent from "../../../core/custom-button";
import { Box } from "@mui/material";
import EngineerMonthlyCalender from "./engineer-monthly-calender";
const EngineerMovements = () => {
  const [isShowCalender, setIsShowCalender] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [EngineerMovements, setEngineerMovements] = useState([]);
  const [engineersData, setEngineerData] = useState([]);
  const [filters, setFilters] = useState({
    year: new Date().getFullYear(),
  });

  useEffect(() => {
    loadData(filters);
  }, []);
  function getCurrentMovement(data) {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = String(today.getMonth() + 1);
    const currentDate = String(today.getDate());

    const result = data
      .map((entry) => {
        const user = entry.user;
        const year = entry.year.toString();
        const month = currentMonth;
        const date = currentDate;

        const attendance = entry.attendance?.[month]?.[date];
        if (attendance) {
          return {
            userId: user.id,
            name: user.name,
            email: user.email,
            phoneNumber: user.phoneNumber,
            status: attendance?.status || "Not Available",
            reason:
              attendance?.status === "IDLE"
                ? "At base location"
                : attendance?.reason || "",
          };
        }
      })
      .filter((ele) => ele && ele);
    return result;
  }

  const loadData = (filters) => {
    const payload = { ...filters };
    setIsLoading(true);
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.ENGINEER_MOVEMENT}`,
      null,
      payload
    )
      .then((response) => {
        setEngineerData(response);
        const results = getCurrentMovement(response);
        setEngineerMovements(results);
        setIsLoading(false);
      })
      .catch((error) => console.error(error));
  };

  return (
    <>
      {isShowCalender ? (
        <EngineerMonthlyCalender
          setIsShowCalender={setIsShowCalender}
          engineersData={engineersData}
        />
      ) : (
        <div className="page-body page-load">
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <p className="tab-name">Engineers Movement</p>
              <p className="section-name">Today's report</p>
            </div>

            <CustomButtonComponent
              variant="contained"
              color="primary"
              onClick={() => setIsShowCalender(true)}
            >
              View Monthly Calender
            </CustomButtonComponent>
          </Box>
          <div className="si-hide-mobile">
            <CustomTable
              header={HeaderConfig}
              data={EngineerMovements || []}
              pageCount={1}
              filters={filters}
              onChange={(page) => {
                setFilters({
                  ...filters,
                });
                loadData({
                  ...filters,
                });
              }}
              isLoading={isLoading}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default EngineerMovements;
